import { motion } from "framer-motion";
import { ChevronDown, Phone, MapPin } from "lucide-react";

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector("#kontakt");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="relative min-h-screen flex items-center pt-20"
      data-testid="hero-section"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1768826117367-98a1fef3a500?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
          alt="Górska droga"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 section-container py-20 lg:py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 bg-yellow-400 text-slate-900 px-4 py-2 rounded-sm font-heading font-bold text-sm tracking-wider mb-8"
            data-testid="hero-badge"
          >
            <MapPin className="w-4 h-4" />
            NIEDŹWIEDŹ 300 | NOWY TARG
          </motion.div>

          {/* Main Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-white leading-none tracking-tight mb-6"
            data-testid="hero-title"
          >
            ZDAJ PRAWO JAZDY
            <span className="block text-yellow-400">ZA PIERWSZYM RAZEM!</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg sm:text-xl text-slate-300 mb-10 max-w-xl leading-relaxed"
            data-testid="hero-subtitle"
          >
            Profesjonalne szkolenie na prawo jazdy kategorii B. Doświadczony instruktor, 
            indywidualne podejście i skuteczne przygotowanie do egzaminu państwowego w Nowym Targu.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4"
            data-testid="hero-cta"
          >
            <button
              onClick={scrollToContact}
              className="btn-primary text-base"
              data-testid="hero-cta-signup"
            >
              Zapisz się na kurs
            </button>
            <a
              href="tel:608490104"
              className="btn-secondary bg-white/10 border-white text-white hover:bg-white hover:text-slate-900 flex items-center justify-center gap-2"
              data-testid="hero-cta-call"
            >
              <Phone className="w-5 h-5" />
              Zadzwoń teraz
            </a>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-16 grid grid-cols-3 gap-8 border-t border-white/20 pt-8"
            data-testid="hero-stats"
          >
            <div className="text-center sm:text-left">
              <div className="font-heading font-bold text-3xl sm:text-4xl text-yellow-400">20+</div>
              <div className="text-sm text-slate-400 mt-1">Lat doświadczenia</div>
            </div>
            <div className="text-center sm:text-left">
              <div className="font-heading font-bold text-3xl sm:text-4xl text-yellow-400">Wysoka</div>
              <div className="text-sm text-slate-400 mt-1">Zdawalność</div>
            </div>
            <div className="text-center sm:text-left">
              <div className="font-heading font-bold text-3xl sm:text-4xl text-yellow-400">500+</div>
              <div className="text-sm text-slate-400 mt-1">Zadowolonych kursantów</div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="text-white/60 cursor-pointer"
          onClick={() => {
            const element = document.querySelector("#o-nas");
            if (element) element.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <ChevronDown className="w-8 h-8" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
